import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ResetPasswordFormGroup } from './auth-user-form-group.interface';
import { Injectable, inject } from '@angular/core';
import { hasDigit, hasLowerCase, hasNonAlphaNumeric, hasUpperCase } from '../../validators/password-validators';

@Injectable()
export class ResetPasswordFormModel {
  public readonly fieldNames = {
    password: 'password',
    confirmPassword: 'confirmPassword',
  };

  public form: FormGroup<ResetPasswordFormGroup>;

  constructor() {
    const formBuilder = inject(FormBuilder);

    this.form = formBuilder.group<ResetPasswordFormGroup>({
      password: new FormControl('', {
        nonNullable: true,
        validators: [
          Validators.required,
          Validators.minLength(6),
          hasDigit,
          hasLowerCase,
          hasUpperCase,
          hasNonAlphaNumeric,
        ],
      }),
      confirmPassword: new FormControl('', {
        nonNullable: true,
        validators: [
          Validators.required,
          Validators.minLength(6),
          hasDigit,
          hasLowerCase,
          hasUpperCase,
          hasNonAlphaNumeric,
          this.isEqualPasswords
        ],
      })
    });
  }

  private isEqualPasswords = (control: AbstractControl) => {
    const value = control.value;

    if (!value) {
      return null;
    }

    return this.form.get('password')?.value === value ? null : { passwordsNotEqual: true };
  }
}
